<ng-container *ngIf="config$ | async as config">
  <app-spend-change-banner *ngIf="config.spendChangeRequestsAlertEnabled"></app-spend-change-banner>
  <app-pending-activation-banner *ngIf="config.pendingActivationAlertEnabled"></app-pending-activation-banner>
  <ng-container></ng-container>
</ng-container>
